import {
    Directive,
    ElementRef,
    AfterViewInit,
    Input,
    HostListener
} from '@angular/core';
import { SKEW_FACTOR_NUMBER } from '~shared/constants';

/**
 * SkewClipPathDirective - Angular directive to dynamically calculate and apply a skew to an element's clip-path.
 * Usage: Apply this directive to an element using the [appSkewClipPath] attribute.
 * It calculates the skew dynamically based on the container's height and updates it on window resize events.
*/
@Directive({
  selector: '[appSkewClipPath]',
})
export class SkewClipPathDirective implements AfterViewInit {
  @Input() skewFactor: number = SKEW_FACTOR_NUMBER;
  private element: HTMLElement;

  constructor(private el: ElementRef) {
    this.element = el.nativeElement;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.calculateSkew();
  }

  ngAfterViewInit() {
    this.calculateSkew();
  }

  private calculateSkew() {
    const containerHeight = this.element.offsetHeight;
    const skewWidth = containerHeight * this.skewFactor;

    this.element.style.clipPath = `polygon(0% -1%, 101% -1%, 101% 101%, ${skewWidth}px 101%)`;
  }
}
